export const formatCurrency = value =>
  (value / 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

export const parseAmountString = amount => Math.round(parseFloat(amount.replace(',', '.')) * 100)